export default __webpack_public_path__ + "static/media/phone.7b483e6f.png";